import React from "react";
import InvestorActivity from ".";
import { useSearchParams } from "react-router-dom";

export default function InvestorActivityWebPage() {
  const [searchParams] = useSearchParams();
  const name = searchParams.get("name") || "";
  const acctId = searchParams.get("acctId") || "";

  return <InvestorActivity acctId={acctId} entityName={name} />;
}
